import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M78.24 1.59009L6.35003 2.86008C6.35003 2.86008 -1.50995 16.3901 2.37005 31.2901C7.49005 50.9301 32.9401 57.2901 21.7101 67.3201C21.7101 67.3201 29.9701 75.9101 39.7101 67.8201C45.6501 75.2501 56.06 71.4501 56.06 71.4501C53.75 67.3201 55.3401 63.6901 55.3401 63.6901C57.7601 66.9901 64.5901 65.0101 64.5901 65.0101C55.1201 55.5401 73.5901 48.0801 79.8401 28.7601C85.0701 12.6001 78.24 1.59009 78.24 1.59009Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
